var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSwitchDefaultR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 48,
  viewBox: "0 0 60 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 9,
  width: 50,
  height: 30,
  rx: 15,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 9,
  width: 50,
  height: 30,
  rx: 15,
  stroke: "#B5B5B5",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 16,
  width: 16,
  height: 16,
  rx: 8,
  fill: "#B5B5B5"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSwitchDefaultR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/switch-default-r.8220f2cb4253608a4ac909794d2afb8c.svg";